<div class="app-payment-amount-form">
  @if (shouldShowExchangeAmount) {
  <nz-form-item>
    <nz-form-label translate>payment.exchangeAmount.label</nz-form-label>
    <nz-form-control [nzExtra]="paymentExchangesAmountFeeTpl">
      <div class="app-payment-amount-form-row">
        <nz-input-number
          (nzBlur)="onExchangeAmountFocusChange(false)"
          (nzFocus)="onExchangeAmountFocusChange(true)"
          (keydown)="handleKeyDown($event)"
          [formControl]="exchangeAmountControl"
          [nzChangeOnWheel]="false"
          [nzMax]="paymentConfig.amountMax"
          [nzMin]="paymentConfig.amountMin"
          [nzParser]="CustomInputNumberParser"
          [nzPlaceHolder]="'payment.amountYouGet.placeholder' | translate: locale.language"
          [nzPrecision]="exchangeAmountPrecision"
          data-cy="payment-amount-input"
          nzSize="large"
        ></nz-input-number>
        <app-currency [currencyCode]="exchangeCurrencyControl.value" [showCode]="true"></app-currency>
      </div>
    </nz-form-control>
  </nz-form-item>
  }

  <ng-template #paymentExchangesAmountFeeTpl>
    @if (paymentConditions && paymentConditions.total && paymentConditions.fee) { @switch (exchangeFeeDisplayType) { @case ('tieredSameCurrency') {
    <span>
      {{ 'payment.amount.extraWithTilde' | translate: locale.language: { total: paymentConditions.total.amount | currencySymbol:
      paymentConditions.total.currency | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
    </span>
    } @case ('tieredDifferentCurrency') {
    <span>
      {{ 'payment.amount.extraDifferentCurrenciesWithTilde' | translate: locale.language: { amount: paymentConditions.initialAmount | currencySymbol:
      paymentConditions.initialCurrency | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
    </span>
    } @case ('nonTieredSameCurrency') {
    <span>
      {{ 'payment.amount.extra' | translate: locale.language: { total: paymentConditions.total.amount | currencySymbol: paymentConditions.total.currency |
      currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
    </span>
    } @case ('nonTieredDifferentCurrency') {
    <span>
      {{ 'payment.amount.extraDifferentCurrencies' | translate: locale.language: { amount: paymentConditions.initialAmount | currencySymbol:
      paymentConditions.initialCurrency| currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
    </span>
    } } }
  </ng-template>
  <nz-form-item>
    <nz-form-label translate>payment.amount.label</nz-form-label>
    <div class="app-payment-amount-form-row app-payment-amount-form-row-currency-select">
      <nz-form-control>
        <nz-input-number
          (nzBlur)="onAmountFocusChange(false)"
          (nzFocus)="onAmountFocusChange(true)"
          (keydown)="handleKeyDown($event)"
          [error]="paymentConditions?.amountError"
          [formControl]="amountControl"
          [nzChangeOnWheel]="false"
          [nzMax]="paymentConfig.amountMax"
          [nzMin]="paymentConfig.amountMin"
          [nzParser]="CustomInputNumberParser"
          [nzPlaceHolder]="'payment.amount.placeholder' | translate: locale.language"
          [nzPrecision]="amountPrecision"
          data-cy="payment-amount-input"
          nzSize="large"
        ></nz-input-number>
      </nz-form-control>
      @if (allowCurrencySelection && !showReadOnlyCurrency) {
      <app-currency-select [currencies]="currencies" [formControl]="currencyControl" nzSize="large"> </app-currency-select>
      }
    </div>
    @if (!shouldShowExchangeAmount) {
    <div class="ant-form-item-extra app-payment-amount-form-extra">
      <ng-container *ngTemplateOutlet="paymentFeeExtraTpl"></ng-container>
    </div>
    }
    <ng-template #paymentFeeExtraTpl>
      @switch (feeDisplayType) { @case ('tieredSameCurrency') {
      <span>
        {{ 'payment.amount.extraWithTilde' | translate: locale.language: { total: paymentConditions.total.amount | currencySymbol:
        paymentConditions.total.currency | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight }
        }}
      </span>
      } @case ('tieredDifferentCurrency') {
      <span>
        {{ 'payment.amount.extraDifferentCurrenciesWithTilde' | translate: locale.language: { amount: paymentConditions.amount | currencySymbol:
        paymentConditions.currency | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
      </span>
      } @case ('nonTieredSameCurrency') {
      <span>
        {{ 'payment.amount.extra' | translate: locale.language: { total: paymentConditions.total.amount | currencySymbol: paymentConditions.total.currency |
        currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
      </span>
      } @case ('nonTieredDifferentCurrency') {
      <span>
        {{ 'payment.amount.extraDifferentCurrencies' | translate: locale.language: { amount: paymentConditions.amount | currencySymbol:
        paymentConditions.currency | currencyRight, fee: paymentConditions.fee.amount | currencySymbol: paymentConditions.fee.currency | currencyRight } }}
      </span>
      } }
    </ng-template>
  </nz-form-item>

  @if (paymentConditions?.exchangeRate && shouldShowExchangeAmount) {
  <p
    [innerHTML]="'payment.exchangeRate.template' | translate: locale.language : {
      exchangeRate: paymentConditions.exchangeRate,
      initialCurrency: (paymentConditions.exchangeRateCurrencyPair.baseCurrency | currencyCodeSymbol),
      currency: (paymentConditions.exchangeRateCurrencyPair.quoteCurrency | currencyCodeSymbol)
    }"
  ></p>
  }
</div>
